function normalizeName(value) {
  return String(value || "").trim().replace(/\s+/g, " ");
}

function limitNamePart(value, maxLength) {
  const normalizedValue = normalizeName(value);
  if (!normalizedValue) return "";
  if (normalizedValue.length <= maxLength) return normalizedValue;
  return `${normalizedValue.slice(0, Math.max(1, maxLength - 1))}.`;
}

export function formatCompactFirstName(firstName) {
  const normalizedFirstName = normalizeName(firstName);
  if (!normalizedFirstName) return "";

  const firstNameParts = normalizedFirstName.split(" ").filter(Boolean);
  if (firstNameParts.length >= 2) {
    return `${firstNameParts[0]} ${firstNameParts[1].charAt(0).toUpperCase()}.`;
  }

  return firstNameParts[0];
}

export function formatProfileDisplayName(userData, { readOnly = false } = {}) {
  const normalizedFirstName = normalizeName(userData?.first_name);
  const normalizedLastName = normalizeName(userData?.last_name);
  const compactFirstName = formatCompactFirstName(normalizedFirstName);
  const firstNameParts = normalizedFirstName.split(" ").filter(Boolean);

  if (!readOnly) {
    return compactFirstName || "Player";
  }

  if (firstNameParts.length >= 2) {
    return compactFirstName || "Player";
  }

  if (compactFirstName && normalizedLastName) {
    return `${compactFirstName} ${normalizedLastName.charAt(0).toUpperCase()}.`;
  }

  return compactFirstName || normalizedLastName || "Player";
}

export function formatNavbarDisplayName(userData) {
  const normalizedFirstName = normalizeName(userData?.first_name);
  const normalizedLastName = normalizeName(userData?.last_name);
  const firstNameParts = normalizedFirstName.split(" ").filter(Boolean);
  const compactPrimaryFirstName = limitNamePart(firstNameParts[0], 16);

  if (firstNameParts.length >= 2) {
    return `${compactPrimaryFirstName} ${firstNameParts[1].charAt(0).toUpperCase()}.`;
  }

  if (compactPrimaryFirstName && normalizedLastName) {
    return `${compactPrimaryFirstName} ${normalizedLastName.charAt(0).toUpperCase()}.`;
  }

  return compactPrimaryFirstName || "Player";
}
